export const RESULT_STATUS_OPTIONS_OBJECT = {
  abnormal: {
    title: "Abnormal",
    isAlert: true,
  },
  abnormal_high: {
    title: "Abnormal ↑ (HIGH)",
    symbol: "↑",
    isAlert: true,
  },
  abnormal_low: {
    title: "Abnormal ↓ (LOW)",
    symbol: "↓",
    isAlert: true,
  },
  abnormal_qualitative: {
    title: "Abnormal ! (Qualitative)",
    symbol: "!",
    isAlert: true,
  },
  abnormal_negative: {
    title: "Negative (Abnormal)",
    isAlert: true,
  },
  normal_negative: {
    title: "Negative (Normal)",
  },
  normal: {
    title: "Normal",
  },
  abnormal_positive: {
    title: "Positive (Abnormal)",
    isAlert: true,
  },
  normal_positive: {
    title: "Positive (Normal)",
  },
};

export const RESULT_STATUS_TITLE_ARRAY = Object.entries(
  RESULT_STATUS_OPTIONS_OBJECT
).map(([key, option]) => {
  return { label: option.title, value: key };
});

// If you update below object, please also update the file
// app/services/doc.rb -> REFERENCE_RANGE_INTERVAL_LOOKUP
export const REFERENCE_RANGE_INTERVAL_LOOKUP = {
  sodium: { title: "Sodium", ranges: { "All Ages": "134-144 mmol/L" } },
  potassium: {
    title: "Potassium",
    ranges: {
      "0-7 days": "3.7-5.2 mmol/L",
      "8-30 days": "3.7-6.4 mmol/L",
      "1-6 months": "3.8-6.0 mmol/L",
      "7 months-1 year": "3.8-5.3 mmol/L",
      ">1 year": "3.5-5.2 mmol/L",
    },
  },
  chloride: { title: "Chloride", ranges: { "All Ages": "96-106 mmol/L" } },
  co2: {
    title: "CO2",
    ranges: {
      "0-30 days": "16-29 mmol/L",
      "31 days-1 year": "15-25 mmol/L",
      "2-5 years": "17-26 mmol/L",
      "6-12 years": "19-27 mmol/L",
      ">12 years": "20-29 mmol/L",
    },
  },
  bun: {
    title: "BUN",
    ranges: {
      "0-14 days": "2.8-23.0 mg/dL",
      "15 to <1 year": "3.4-16.8 mg/dL",
      "1 to <10 years": "9.0-22.1 mg/dL",
      "10 to <19 years (male)": "7.3-21 mg/dL",
      "10 to <19 years (female)": "7.3-19 mg/dL",
      "19 years and above": "6-20 mg/dL",
    },
  },
  creatinine: {
    title: "Creatinine",
    ranges: {
      "0-14 days": "0.32-0.92 mg/dL",
      "15 days-23 months": "0.10-0.35 mg/dL",
      "2-4 years": "0.20-0.43 mg/dL",
      "5-11 years": "0.31-0.61 mg/dL",
      "12-14 years": "0.45-0.81 mg/dL",
      "15-18 years": "0.62-1.08 mg/dL",
      "19 + years": "0.76-1.27 mg/dL",
    },
  },
  serum_chemistries_glucose: {
    title: "Serum Chemistries - Glucose",
    ranges: {
      "All Ages": "70-99 mg/dL",
    },
  },
  calcium: {
    title: "Calcium",
    ranges: {
      "0-10 days": "8.6-10.4 mg/dL",
      "11 days-1 year": "9.2-11.0 mg/dL",
      "2-11 years": "9.1-10.5 mg/dL",
      "12-17 years": "8.9-10.4 mg/dL",
      "19-59 years": "8.7-10.2 mg/dL",
      "60 years and above": "8.6-10.2 mg/dL",
    },
  },
  magnesium: {
    title: "Magnesium",
    ranges: {
      "0-30 days": "1.6-2.4 mg/dL",
      "1-6 months": "1.8-2.5 mg/dL",
      "7 months-1 year": "1.7-2.4 mg/dL",
      "2-5 years": "1.6-2.3 mg/dL",
      "6-17 years": "1.7-2.3 mg/dL",
      "18 years and above": "1.6-2.3 mg/dL",
    },
  },
  phosphorus: {
    title: "Phosphorus",
    ranges: {
      "0-6 months, MALE": "4.2-7.8 mg/dL",
      "0-6 months, FEMALE": "3.4-7.9 mg/dL",
      "7 months-1 year, MALE": "4.0-6.8 mg/dL",
      "7 months-1 year, FEMALE": "4.0-6.8 mg/dL",
      "2-19 years, MALE": "3.4-5.5 mg/dL",
      "2-19 years, FEMALE": "3.3-5.1 mg/dL",
      "20 years and above, MALE": "2.8-4.1 mg/dL",
      "20 years and above, FEMALE": "3.0-4.3 mg/dL",
    },
  },
  ast: {
    title: "AST",
    ranges: {
      "0-6 months": "0-120 IU/L",
      "7-11 months": "0-110 IU/L",
      "1-4 years": "0-75 IU/L",
      "5-9 years": "0-60 IU/L",
      "9 years and above": "0-40 IU/L",
    },
  },
  alt: {
    title: "ALT",
    ranges: {
      "0-11 years, MALE": "0-29 IU/L",
      "0-11 years, FEMALE": "0-29 IU/L",
      "12-17 years, MALE": "0-30 IU/L",
      "12-17 years, FEMALE": "0-30 IU/L",
      "17 years and above, MALE": "0-44 IU/L",
      "17 years and above, FEMALE": "0-44 IU/L",
    },
  },
  bilirubin_total: {
    title: "Bilirubin, total",
    ranges: {
      "24 hours": "0.0-8.0 mg/dL",
      "48 hours": "0.0-13.2 mg/dL",
      "72 hours": "0.0-5.6 mg/dL",
      "96 hours-1 month": "0.0-16.6 mg/dL",
      "> 1 month and adults": "0.0-1.2 mg/dL",
    },
  },
  bilirubin_direct: {
    title: "Bilirubin, direct",
    ranges: {
      "0-31 days": "0.0-0.6 mg/dL",
      ">31 days and adults": "0.0-0.4 mg/dL",
    },
  },
  bilirubin_indirect: {
    title: "Bilirubin, indirect",
    ranges: {
      "24 hours": "0.0-7.4 mg/dL",
      "48 hours": "0.0-12.6 mg/dL",
      "72 hours": "0.0-15.0 mg/dL",
      "96 hours-1 month": "0.0-16.0 mg/dL",
      "> 1 month and adults": "0.1-0.8 mg/dL",
    },
  },
  alkaline_phosphatase: {
    title: "Alkaline Phosphatase",
    ranges: {
      "0-5 days, MALE": "47-127 IU/L",
      "0-5 days, FEMALE": "47-127 IU/L",
      "6-10 days, MALE": "29-242 IU/L",
      "6-10 days, FEMALE": "29-242 IU/L",
      "11-20 days, MALE": "109-357 IU/L",
      "11-20 days, FEMALE": "109-357 IU/L",
      "21-30 days, MALE": "94-494 IU/L",
      "21-30 days, FEMALE": "94-494 IU/L",
      "1-2 months, MALE": "149-539 IU/L",
      "1-2 months, FEMALE": "149-539 IU/L",
      "3-6 months, MALE": "131-452 IU/L",
      "3-6 months, FEMALE": "131-452 IU/L",
      "7-11 months, MALE": "117-401 IU/L",
      "7-11 months, FEMALE": "117-401 IU/L",
      "12 months to 6 years, MALE": "158-369 IU/L",
      "12 months to 6 years, FEMALE": "158-369 IU/L",
      "7-12 years, MALE": "150-409 IU/L",
      "7-12 years, FEMALE": "150-409 IU/L",
      "13 years, MALE": "156-435 IU/L",
      "13 years, FEMALE": "156-435 IU/L",
      "14 years, MALE": "114-375 IU/L",
      "14 years, FEMALE": "114-375 IU/L",
      "15 years, MALE": "88-279 IU/L",
      "15 years, FEMALE": "88-279 IU/L",
      "16 years, MALE": "73-233 IU/L",
      "16 years, FEMALE": "73-233 IU/L",
      "17 years, MALE": "61-197 IU/L",
      "17 years, FEMALE": "61-197 IU/L",
      "18-20 years, MALE": "55-170 IU/L",
      "18-20 years, FEMALE": "55-170 IU/L",
      "20 years and above, MALE": "45-115 IU/L",
      "20 years and above, FEMALE": "30-100 U/L",
    },
  },
  albumin: {
    title: "Albumin",
    ranges: {
      "0-7 days": "3.6-4.9 g/dL",
      "8-30 days": "3.5-4.6 g/dL",
      "1-6 months": "3.7-4.8 g/dL",
      "7-24 months": "4.0-5.0 g/dL",
      "3-5 years": "4.1-5.0 g/dL",
      "6-12 years": "4.2-5.0 g/dL",
      "13-30 years": "4.3-5.2 g/dL",
      "31-50 years": "4.1-5.1 g/dL",
      "51-60 years": "3.8-4.9 g/dL",
      "61-70 years": "3.9-4.9 g/dL",
      "71-80 years": "3.8-4.8 g/dL",
      "81-89 years": "3.7-4.7 g/dL",
      "89 years and above": "3.6-4.6 g/dL",
    },
  },
  serum_chemistries_protein: {
    title: "Serum Chemistries - Protein",
    ranges: {
      "0-6 months": "4.6-7.2 g/dL",
      "7 months-1 year": "5.7-8.2 g/dL",
      ">1 year and adults": "6.0-8.5 g/dL",
    },
  },
  amylase: {
    title: "Amylase",
    ranges: {
      "0-30 days": "22-92 U/L",
      "31 days-6 months": "8-71 U/L",
      "7 months-1 year": "24-98 U/L",
      "1 year and above": "31-110 U/L",
    },
  },
  lipase: {
    title: "Lipase",
    ranges: {
      "0-6 months, MALE": "8-37 U/L",
      "0-6 months, FEMALE": "9-50 U/L",
      "7 months-1 year, MALE": "11-34 U/L",
      "7 months-1 year, FEMALE": "11-34 U/L",
      "2-17 years, MALE": "11-38 U/L",
      "2-17 years, FEMALE": "11-38 U/L",
      "18 years and above, MALE": "13-78 U/L",
      "18 years and above, FEMALE": "13-78 U/L",
    },
  },
  ferritin: {
    title: "Ferritin",
    ranges: {
      "0-5 months, MALE": "13-273 ng/mL",
      "0-5 months, FEMALE": "12-219 ng/mL",
      "6-12 months, MALE": "12-95 ng/mL",
      "6-12 months, FEMALE": "12-110 ng/mL",
      "1-5 years, MALE": "12-64 ng/mL",
      "1-5 years, FEMALE": "12-71 ng/mL",
      "6-11 years, MALE": "16-77 ng/mL",
      "6-11 years, FEMALE": "15-79 ng/mL",
      "12-19 years, MALE": "16-124 ng/mL",
      "12-19 years, FEMALE": "15-77 ng/mL",
      "19 years and above, MALE": "30-400 ng/mL",
      "19 years and above, FEMALE": "15-150 ng/mL",
    },
  },
  iron: {
    title: "Iron",
    ranges: {
      "0-30 days, MALE": "35-160",
      "0-30 days, FEMALE": "27-133",
      "1 month-1 year, MALE": "18-126",
      "1 month-1 year, FEMALE": "18-126",
      "2-12 years, MALE": "28-147",
      "2-12 years, FEMALE": "28-147",
      "13-17 years, MALE": "26-169",
      "13-17 years, FEMALE": "26-169",
      "18-60 years, MALE": "38-169",
      "18-60 years, FEMALE": "27-169",
      "60 years and above, MALE": "38-169",
      "60 years and above, FEMALE": "27-139",
    },
  },
  tibc: {
    title: "TIBC",
    ranges: {
      "All Ages": "250-450 ug/dL",
    },
  },
  transferrin: {
    title: "Transferrin",
    ranges: {
      "0-6 months, MALE": "157-302 mg/dL",
      "0-6 months, FEMALE": "182-331 mg/dL",
      "7-12 months, MALE": "224-362 mg/dL",
      "7-12 months, FEMALE": "224-362 mg/dL",
      "13-17 years, MALE": "219-350 mg/dL",
      "13-17 years, FEMALE": "234-394 mg/dL",
      "18-80 years, MALE": "177-329 mg/dL",
      "18-80 years, FEMALE": "192-364 mg/dL",
      "80 years and above, MALE": "149-313 mg/dL",
      "80 years and above, FEMALE": "149-313 mg/dL",
    },
  },
  total_cholesterol: {
    title: "Total Cholesterol",
    ranges: {
      "0-19 years": "100-169 mg/dL",
      "19 years and above": "100-199 mg/dL",
    },
  },
  hdl_cholesterol: {
    title: "HDL Cholesterol",
    ranges: {
      "All Ages": ">39 mg/dL",
    },
  },
  triglycerides: {
    title: "Triglycerides",
    ranges: {
      "0-9 years": "0-74 mg/dL",
      "10-19 years": "0-89 mg/dL",
      "19 years and above": "0-149 mg/dL",
    },
  },
  ldl_cholesterol: {
    title: "LDL Cholesterol",
    ranges: {
      "0-19 years": "0-109 mg/dL",
      "19 years and above": "0-99 mg/dL",
    },
  },
  b_type_natriuretic_peptide: {
    title: "B-Type Natriuretic Peptide (BNP)",
    ranges: {
      "All Ages": "0-100 pg/mL",
    },
  },
  serum_osmolality: {
    title: "Serum Osmolality",
    ranges: {
      "0-30 days": "Neonate may be as low as 266 mOsmol/kg",
      "31 days and above": "275-295 mOsmol/kg",
    },
  },
  procalcitonin: {
    title: "Procalcitonin",
    ranges: {
      Neonates:
        "No clear reference range: https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9464813/",
      "30 days and above": "0.0-0.08 ng/mL",
    },
  },
  troponin_t_highly_sensitive: {
    title: "Troponin T (Highly Sensitive)",
    ranges: {
      "All Ages, MALE": "0-22 ng/L",
      "All Ages, FEMALE": "0-14 ng/L",
    },
  },
  c_reactive_protein: {
    title: "C-Reactive Protein (CRP)",
    ranges: {
      "0-30 days, MALE": "Not established",
      "0-30 days, FEMALE": "Not established",
      "31 days-17 years, MALE": "0-7 mg/L",
      "31 days-17 years, FEMALE": "0-9 mg/L",
      "18 years and above, MALE": "0-10 mg/L",
      "18 years and above, FEMALE": "0-10 mg/L",
    },
  },
  crp_highly_sensitive: {
    title: "CRP highly sensitive - hs-CRP",
    ranges: {
      "Used only in adults": "0-3.0 mg/L",
    },
  },
  general_appearance: {
    title: "General Appearance",
    ranges: {
      "All Ages": "Clear",
    },
  },
  specific_gravity: {
    title: "Specific Gravity",
    ranges: {
      "0-18 years": "1.003-1.030",
      "18 years and above": "1.005-1.030",
    },
  },
  ph: {
    title: "pH",
    ranges: {
      "0-18 years": "4.5-8.0",
      "18 years and above": "4.5-7.5",
    },
  },
  urine_studies_protein: {
    title: "Urine Studies - Protein",
    ranges: {
      "All Ages": "Negative/trace",
    },
  },
  urine_studies_glucose: {
    title: "Urine Studies - Glucose",
    ranges: {
      "All Ages": "Negative",
    },
  },
  urine_studies_ketones: {
    title: "Urine Studies - Ketones",
    ranges: {
      "All Ages": "Negative",
    },
  },
  urine_studies_bilirubin: {
    title: "Urine Studies - Bilirubin",
    ranges: {
      "All Ages": "Negative",
    },
  },
  urine_studies_urobilinogen: {
    title: "Urine Studies - Urobilinogen",
    ranges: {
      "All Ages": "0.2-1.0 mg/dL",
    },
  },
  blood: {
    title: "Blood",
    ranges: {
      "All Ages": "Negative",
    },
  },
  nitrite: {
    title: "Nitrite",
    ranges: {
      "All Ages": "Negative",
    },
  },
  leukocyte_esterace: {
    title: "Leukocyte Esterace",
    ranges: {
      "All Ages": "Negative",
    },
  },
  white_blood_cells: {
    title: "White Blood Cells",
    ranges: {
      "All Ages": "0-5/HPF",
    },
  },
  red_blood_cells: {
    title: "Red Blood Cells",
    ranges: {
      "All Ages": "0-5/HPF",
    },
  },
  bacteria: {
    title: "Bacteria",
    ranges: {
      "All Ages": "None seen",
    },
  },
  casts: {
    title: "Casts",
    ranges: {
      "All Ages": "None seen",
    },
  },
  creatinine_urine: {
    title: "Creatinine, Urine",
    ranges: {
      "All Ages": "Not established",
    },
  },
  protein_urine: {
    title: "Protein, Urine",
    ranges: {
      "All Ages": "Not established",
    },
  },
  alb_creat_ratio: {
    title: "Alb/Creat Ratio",
    ranges: {
      "All Ages": "0-29 mg/g Creatinine",
    },
  },
  follicle_stimulating_hormone: {
    title: "Follicle Stimulating Hormone (FSH)",
    ranges: {
      "<24 hours": "<0.2-0.8 mIU/mL",
      "1 day": "<0.2-0.8 mIU/mL",
      "2 days": "<0.2-0.8 mIU/mL",
      "3 days": "<0.2-2.4 mIU/mL",
      "4 days": "<0.2-2.3 mIU/mL",
      "5 days": "<0.2-3.4 mIU/mL",
      "6 days": "<0.2-4.5 mIU/mL",
      "7 days": "<0.2-21.4 mIU/mL",
      "8-30 days": "<0.2-22.2 mIU/mL",
      "1-12 months, MALE": "Not established",
      "1-12 months, FEMALE": "Not established",
      "1-4 years, MALE": "0.2-2.8 mIU/mL",
      "1-4 years, FEMALE": "0.2-11.1 mIU/mL",
      "5-9 years, MALE": "0.4-3.8 mIU/mL",
      "5-9 years, FEMALE": "0.3-11.1 mIU/mL",
      "10-12 years, MALE": "0.4-4.6 mIU/mL",
      "10-12 years, FEMALE": "2.1-11.1 mIU/mL",
      "13-16 years, MALE": "1.5-12.9 mIU/mL",
      "13-16 years, FEMALE": "1.6-17.0 mIU/mL",
      "16+ (male)": "1.5-12.4 mIU/mL",
      "16+ (female): Follicular": "3.5-12.5 mIU/mL",
      "16+ (female): Ovulatory": "4.7-21.5 mIU/mL",
      "16+ (female): Luteal": "1.7-7.7 mIU/mL",
      "16+ (female): Postmenopausal": "25.8-134.8 mIU/mL",
    },
  },
  luteinizing_hormone: {
    title: "Luteinizing Hormone (LH)",
    ranges: {
      "<24 hours": "<0.2-1.0 mIU/mL",
      "1 day": "<0.2-0.8 mIU/mL",
      "2 days": "<0.2-0.6 mIU/mL",
      "3 days": "<0.2-2.7 mIU/mL",
      "4 days": "<0.2-1.7 mIU/mL",
      "5 days": "<0.2-3.1 mIU/mL",
      "6 days": "<0.4-6.4 mIU/mL",
      "7 days": "<0.2-5.6 mIU/mL",
      "8-30 days": "<0.2-7.8 mIU/mL",
      "1 month-12 months, MALE": "<0.2-0.4 mIU/mL",
      "1 month-12 months, FEMALE": "<0.2-0.4 mIU/mL",
      "1-4 years, MALE": "<0.2-1.3 mIU/mL",
      "1-4 years, FEMALE": "<0.2-0.5 mIU/mL",
      "5-9 years, MALE": "<0.2-1.4 mIU/mL",
      "5-9 years, FEMALE": "<0.2-3.1 mIU/mL",
      "10-12 years, MALE": "<0.2-7.8 mIU/mL",
      "10-12 years, FEMALE": "<0.2-11.9 mIU/mL",
      "13-16 years, MALE": "1.3-9.8 mIU/mL",
      "13-16 years, FEMALE": "0.5-41.7 mIU/mL",
      "Adult Male": "1.7-8.6 mIU/mL",
      "Adult Female: Follicular": "2.4-12.6 mIU/mL",
      "Adult Female: Ovulation": "14.0-95.6 mIU/mL",
      "Adult Female: Luteal": "1.0-11.4 mIU/mL",
      "Adult Female: Postmenopausal": "7.7-58.5 mIU/mL",
    },
  },
  thyroid_stimulating_hormone: {
    title: "Thyroid Stimulating Hormone (TSH)",
    ranges: {
      "0-6 days": "0.700-15.2 µIU/mL",
      "7 days-3 months": "0.720-11.0 µIU/mL",
      "3 months 1 day-12 months": "0.730-8.35 µIU/mL",
      "1-5 years": "0.700-5.97 µIU/mL",
      "6-10 years": "0.600-4.84 µIU/mL",
      "10 years and above": "0.450-4.5 µIU/mL",
    },
  },
  free_t4: {
    title: "Free T4",
    ranges: {
      "0-3 days": "0.66-2.71 ng/dL",
      "4-30 days": "0.83-3.09 ng/dL",
      "31 days-12 months": "0.48-2.34 ng/dL",
      "13 months-5 years": "0.85-1.75 ng/dL",
      "6-10 years": "0.90-1.67 ng/dL",
      "11-19 years": "0.93-1.60 ng/dL",
      "19 years and above": "0.82-1.77 ng/dL",
    },
  },
  triiodothyronine_t3_ria: {
    title: "Triiodothyronine (T3) (RIA)",
    ranges: {
      "0-3 days": "96-292 ng/dL",
      "4-30 days": "62-243 ng/dL",
      "31 days-12 months": "81-281 ng/dL",
      "13 months-5 years": "81-281 ng/dL",
      "6-10 years": "92-219 ng/dL",
      "10 years and above": "71-180 ng/dL",
    },
  },
  triiodothyronine_resin_uptake: {
    title: "Triiodothyronine Resin Uptake (T3 Uptake)",
    ranges: {
      "0-11 months, MALE": "23-34 ng/dL",
      "0-11 months, FEMALE": "23-36 ng/dL",
      "1-3 years, MALE": "24-35 ng/dL",
      "1-3 years, FEMALE": "24-36 ng/dL",
      "4-6 years, MALE": "24-34 ng/dL",
      "4-6 years, FEMALE": "24-35 ng/dL",
      "7-11 years, MALE": "24-33 ng/dL",
      "7-11 years, FEMALE": "24-35 ng/dL",
      "12-15 years, MALE": "25-37 ng/dL",
      "12-15 years, FEMALE": "23-37 ng/dL",
      "16-18 years, MALE": "24-38 ng/dL",
      "16-18 years, FEMALE": "23-35 ng/dL",
      "18 years and above, MALE": "24-39 ng/dL",
      "18 years and above, FEMALE": "24-39 ng/dL",
    },
  },
  intact_parathyroid_hormone: {
    title: "Intact Parathyroid Hormone (PTH)",
    ranges: {
      "<1 month": "7.0-59 pg/mL",
      "4 weeks-11 months": "8.0-61 pg/mL",
      "12 months-10 years": "11-59 pg/mL",
      "11-17 years": "15-68 pg/mL",
      "18 years and above": "15-65 pg/mL",
    },
  },
  hemoglobin_a1c: {
    title: "Hemoglobin A1c",
    ranges: {
      "All Ages": "4.8-5.6%",
    },
  },
  wbc: {
    title: "WBC",
    ranges: {
      "0-7 days": "3.6-12.5 x10<sup>3</sup>/μL",
      "8-30 days": "4.5-14.4 x10<sup>3</sup>/μL",
      "31-90 days": "4.4-13.1 x10<sup>3</sup>/μL",
      "91 days-11 months": "5.2-14.5 x10<sup>3</sup>/μL",
      "1-7 years": "4.3-12.4 x10<sup>3</sup>/μL",
      "8-12 years": "3.7-10.5 x10<sup>3</sup>/μL",
      "12 years and above": "3.4-10.8 x10<sup>3</sup>/μL",
    },
  },
  rbc: {
    title: "RBC",
    ranges: {
      "0-7 days": "3.68-5.77 x10<sup>6</sup>/μL",
      "8-30 days": "3.29-5.5 x10<sup>6</sup>/μL",
      "31-90 days": "2.72-4.84 x10<sup>6</sup>/μL",
      "91 days-11 months": "3.86-5.16 x10<sup>6</sup>/μL",
      "1-7 years": "3.96-5.30 x10<sup>6</sup>/μL",
      "8-12 years": "3.91-5.45 x10<sup>6</sup>/μL",
      "12 years and above, MALE": "4.14-5.80 x10<sup>6</sup>/μL",
      "12 years and above, FEMALE": "3.77- 5.28 x10<sup>6</sup>/μL",
    },
  },
  hemoglobin: {
    title: "Hemoglobin",
    ranges: {
      "0-7 days": "10.7-20.5 g/dL",
      "8-30 days": "10.5-18.7 g/dL",
      "31-90 days": "8.8-14.3 g/dL",
      "91 days-11 months": "10.4-14.1 g/dL",
      "1-7 years": "10.9 -14.8 g/dL",
      "8-12 years": "11.7-15.7 g/dL",
      "13-15 years": "12.6-17.7 g/dL",
      "15 years and above, MALE": "13.0-17.7 g/dL",
      "15 years and above, FEMALE": "11.1-15.9 g/dL",
    },
  },
  hematocrit: {
    title: "Hematocrit",
    ranges: {
      "0-7 days": "31.9-57.2 %",
      "8-30 days": "30.7-53.7 %",
      "31-90 days": "26.6-41.0 %",
      "91 days-11 months": "31.0-41.0 %",
      "1-7 years": "32.4-43.3 %",
      "8-12 years": "34.8-45.8 %",
      "12 years and above, MALE": "37.5-51.0 %",
      "12 years and above, FEMALE": "34.0-46.6 %",
    },
  },
  mcv: {
    title: "MCV",
    ranges: {
      "0-7 days": "79-110 fL",
      "8-30 days": "81-109 fL",
      "31-90 days": "81-97 fL",
      "91 days-11 months": "73-87 fL",
      "1-7 years": "75-89 fL",
      "8-12 years": "77-91 fL",
      "12 years and above": "79-97 fL",
    },
  },
  mch: {
    title: "MCH",
    ranges: {
      "0-7 days": "26.1-38.7 pg/cell",
      "8-30 days": "27.5-37.6 pg/cell",
      "31-90 days": "27.1-34.0 pg/cell",
      "91 days-11 months": "24.2-30.1 pg/cell",
      "1-7 years": "24.6-30.7 pg/cell",
      "8-12 years": "25.7-31.5 pg/cell",
      "12 years and above": "26.6-33.0 pg/cell",
    },
  },
  mchc: {
    title: "MCHC",
    ranges: {
      "0-7 days": "31.9-36.8 g/dL",
      "8-30 days": "32.0-36.4 g/dL",
      "31-90 days": "31.9-36.0 g/dL",
      "91 days-11 months": "31.5-36.0 g/dL",
      "1-12 years": "31.7-36.0 g/dL",
      "12 years and above": "31.5-35.7 g/dL",
    },
  },
  rdw: {
    title: "RDW",
    ranges: {
      "All Ages": "11.6-15.4 %",
    },
  },
  platelets: {
    title: "Platelets",
    ranges: {
      "0-7 days": "140-396 x10<sup>3</sup>/μL",
      "8-30 days": "139-531 x10<sup>3</sup>/μL",
      "30 days and above": "150-450 x10<sup>3</sup>/μL",
    },
  },
  neutrophils_percentage: {
    title: "Neutrophils %",
    ranges: {
      "All Ages": "No reference range",
    },
  },
  lymphs_percentage: {
    title: "Lymphs %",
    ranges: {
      "All Ages": "No reference range",
    },
  },
  monocytes_percentage: {
    title: "Monocytes %",
    ranges: {
      "All Ages": "No reference range",
    },
  },
  eosinophils_percentage: {
    title: "Eosinophils %",
    ranges: {
      "All Ages": "No reference range",
    },
  },
  basophils_percentage: {
    title: "Basophils %",
    ranges: {
      "All Ages": "No reference range",
    },
  },
  neutrophils_absolute: {
    title: "Neutrophils (absolute)",
    ranges: {
      "0-7 days": "1.2-6.12 x10<sup>3</sup>/μL",
      "8-30 days": "1.2-4.8 x10<sup>3</sup>/μL",
      "31-90 days": "0.8-3.8 x10<sup>3</sup>/μL",
      "91 days-11 months": "1.0-4.0 x10<sup>3</sup>/μL",
      "1-7 years": "0.9-5.4 x10<sup>3</sup>/μL",
      "8-12 years": "1.2-6.0 x10<sup>3</sup>/μL",
      "12 years and above": "1.4-7.0 x10<sup>3</sup>/μL",
    },
  },
  lymphs_absolute: {
    title: "Lymphs (absolute)",
    ranges: {
      "0-7 days": "0.9-5.0 x10<sup>3</sup>/μL",
      "8-30 days": "0.9-9.1 x10<sup>3</sup>/μL",
      "31-90 days": "1.2-9.2 x10<sup>3</sup>/μL",
      "91 days-11 months": "2.9-9.5 x10<sup>3</sup>/μL",
      "1-7 years": "1.6-5.9 x10<sup>3</sup>/μL",
      "8-12 years": "1.3-3.7 x10<sup>3</sup>/μL",
      "12 years and above": "0.7-3.1 x10<sup>3</sup>/μL",
    },
  },
  monocytes_absolute: {
    title: "Monocytes (absolute)",
    ranges: {
      "0-7 days": "0.2-1.3 x10<sup>3</sup>/μL",
      "8-30 days": "0.1-1.6 x10<sup>3</sup>/μL",
      "31-90 days": "0.2-1.2 x10<sup>3</sup>/μL",
      "91 days-11 months": "0.2-1.1 x10<sup>3</sup>/μL",
      "1-7 years": "0.2-1.0 x10<sup>3</sup>/μL",
      "8-12 years": "0.1-0.8 x10<sup>3</sup>/μL",
      "12 years and above": "0.1-0.9 x10<sup>3</sup>/μL",
    },
  },
  eosinophils_absolute: {
    title: "Eosinophils (absolute)",
    ranges: {
      "0-7 days": "0.0-0.6 x10<sup>3</sup>/μL",
      "8-30 days": "0.0-0.7 x10<sup>3</sup>/μL",
      "31 days-11 months": "0.0-0.4 x10<sup>3</sup>/μL",
      "1-7 years": "0.0-0.3 x10<sup>3</sup>/μL",
      "7 years and above": "0.0-0.4 x10<sup>3</sup>/μL",
    },
  },
  basophils_absolute: {
    title: "Basophils (absolute)",
    ranges: {
      "0-7 days": "0.0-0.6 x10<sup>3</sup>/μL",
      "8 days-11 months": "0.0-0.4 x10<sup>3</sup>/μL",
      "1-17 years": "0.0-0.3 x10<sup>3</sup>/μL",
      "17 years and above": "0.0-0.2 x10<sup>3</sup>/μL",
    },
  },
  immature_granulocytes_percentage: {
    title: "Immature Granulocytes (%)",
    ranges: {
      "All Ages": "Not established",
    },
  },
  immature_granulocytes_absolute: {
    title: "Immature Granulocytes (absolute)",
    ranges: {
      "All Ages": "0.0-0.1 x10<sup>3</sup>/μL",
    },
  },
  erythrocyte_sedimentation_rate: {
    title: "Erythrocyte Sedimentation Rate",
    ranges: {
      "0-49 years, MALE": "0-15 mm/hr",
      "0-49 years, FEMALE": "0-32 mm/hr",
    },
  },
  aptt: {
    title: "aPTT",
    ranges: {
      "0-3 days": "Not established",
      "4 days-6 months": "26 - 38 sec",
      "7 months-17 years": "26 - 35 sec",
      "18 years and above": "24 - 33 sec",
    },
  },
  inr_international_normalized_ratio: {
    title: "INR (International Normalized Ratio)",
    ranges: {
      "0-1 month": "0.9 - 1.4",
      "1 month and above": "0.9 - 1.2",
    },
  },
  other: {
    title: "Other",
    ranges: {
      Other: "Other",
    },
  },
};

export const REFERENCE_RANGE_LAB_NAMES = Object.entries(
  REFERENCE_RANGE_INTERVAL_LOOKUP
).map(([key, value]) => ({
  value: key,
  label: value.title,
}));

export const FIRST_LAB_VALUE = Object.keys(REFERENCE_RANGE_INTERVAL_LOOKUP)[0];
export const FIRST_RESULT_STATUS = Object.keys(RESULT_STATUS_OPTIONS_OBJECT)[0];
export const FIRST_LAB_VALUE_RANGE_INTERVAL = Object.keys(
  REFERENCE_RANGE_INTERVAL_LOOKUP[FIRST_LAB_VALUE].ranges
)[0];
export const FIRST_LAB_VALUE_RANGE =
  REFERENCE_RANGE_INTERVAL_LOOKUP[FIRST_LAB_VALUE].ranges[
    FIRST_LAB_VALUE_RANGE_INTERVAL
  ];
